import React from "react";
import SpotFormWizard from "../components/spotForm/SpotFormWizard";

export default function NewSpotPage() {
    return (
        <div className="blog-page-root">
            <div className="blog-page-inner new-spot-glass-inner">
                <div className="cms-page-panel new-spot-glass-panel">
                    <h1 className="new-spot-glass-title">Добавить новую точку</h1>
                    <SpotFormWizard mode="create" />
                </div>
            </div>
        </div>
    );
}
